import { useMemo } from "react";

import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

import type { OutboundNetworkInvite } from "../components/SupplierNetwork/types";

interface UseOutboundNetworkInvitesReturn {
  data: OutboundNetworkInvite[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useOutboundNetworkInvites(): UseOutboundNetworkInvitesReturn {
  const { role } = useRoleContext();
  const isInvalidRole = role && role.type !== "SHIPPER";

  const url =
    role && !isInvalidRole
      ? `/shippers/${role.id}/network-invites/outbound-pending`
      : null;

  const { data, loading, error, refetch } = useSwrFetch<
    OutboundNetworkInvite[]
  >({
    url,
    errorMessage: isInvalidRole
      ? "This feature is only available for shipper users"
      : "Failed to fetch outbound network invites",
  });

  const sorted = useMemo(
    () =>
      data
        ? [...data].sort(
            (a, b) =>
              new Date(b.created_at).getTime() -
              new Date(a.created_at).getTime(),
          )
        : [],
    [data],
  );

  if (isInvalidRole) {
    return {
      data: [],
      loading: false,
      error: "This feature is only available for shipper users",
      refetch: () => {},
    };
  }

  return {
    data: sorted,
    loading,
    error,
    refetch,
  };
}
